import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import notificationService from '../services/notificationService';

export const useNotifications = () => {
    const { user } = useAuth();
    const [isInitialized, setIsInitialized] = useState(false);
    const [permissionStatus, setPermissionStatus] = useState<'granted' | 'denied' | 'default'>('default');

    useEffect(() => {
        if (!user) return;

        const initializeNotifications = async () => {
            try {
                // Initialize the notification service
                await notificationService.initialize();
                
                // Check permission status
                const status = notificationService.getPermissionStatus();
                setPermissionStatus(status.granted ? 'granted' : status.denied ? 'denied' : 'default');
                
                // Subscribe to push notifications if permission is granted
                if (status.granted) {
                    await notificationService.subscribeToPushNotifications();
                }
                
                setIsInitialized(true);
            } catch (error) {
                console.error('Failed to initialize notifications:', error);
                setIsInitialized(true); // Still mark as initialized to prevent retries
            }
        };

        initializeNotifications();
    }, [user]);

    const requestPermission = async () => {
        try {
            const result = await notificationService.requestPermission();
            setPermissionStatus(result.granted ? 'granted' : result.denied ? 'denied' : 'default');
            
            if (result.granted) {
                await notificationService.subscribeToPushNotifications();
            }
            
            return result;
        } catch (error) {
            console.error('Failed to request notification permission:', error);
            throw error;
        }
    };

    return {
        isInitialized,
        permissionStatus,
        requestPermission,
    };
};
